import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const PauseIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-labelledby="titleId"
      aria-label="Pause icon"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.02359 5.30771C5.89614 5.30771 5.79282 5.41103 5.79282 5.53848V18.4616C5.79282 18.589 5.89614 18.6923 6.02359 18.6923H8.15959C8.28704 18.6923 8.39036 18.589 8.39036 18.4616V5.53848C8.39036 5.41103 8.28704 5.30771 8.15959 5.30771H6.02359ZM4.4082 5.53848C4.4082 4.64633 5.13143 3.9231 6.02359 3.9231H8.15959C9.05174 3.9231 9.77498 4.64633 9.77498 5.53848V18.4616C9.77498 19.3537 9.05174 20.0769 8.15959 20.0769H6.02359C5.13143 20.0769 4.4082 19.3537 4.4082 18.4616V5.53848Z"
        fill={props.fill || "currentColor" || "#202123"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4552 5.30771C14.3278 5.30771 14.2245 5.41103 14.2245 5.53848V18.4616C14.2245 18.589 14.3278 18.6923 14.4552 18.6923H16.5912C16.7186 18.6923 16.822 18.589 16.822 18.4616V5.53848C16.822 5.41103 16.7186 5.30771 16.5912 5.30771H14.4552ZM12.8398 5.53848C12.8398 4.64633 13.5631 3.9231 14.4552 3.9231H16.5912C17.4834 3.9231 18.2066 4.64633 18.2066 5.53848V18.4616C18.2066 19.3537 17.4834 20.0769 16.5912 20.0769H14.4552C13.5631 20.0769 12.8398 19.3537 12.8398 18.4616V5.53848Z"
        fill={props.fill || "currentColor" || "#202123"}
      />
    </svg>
  );
};

export default PauseIcon;
